import { makeStyles } from '@material-ui/styles';
import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import {
  Button, IconButton, Grid,
  colors,
} from '@material-ui/core';
import CameraIcon from '@material-ui/icons/CameraAlt';
import UploadIcon from '@material-ui/icons/Publish';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {},
  image: {
    maxWidth: '100%',
    minWidth: 75,
    height: 75,
    marginRight: theme.spacing(2),
    borderRadius: 10,
    objectFit: 'contain'
  },
  label: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 2)
  },
  button: {},
  close: {
    padding: 0,
    position: 'absolute',
    right: 0,
    top: -10
  },
  wrapper: {
    position: 'relative',
    display: 'inline-block'
  },
  cameraIcon: {
    width: 75,
    height: 75,
    backgroundColor: '#ECEFF8',
    borderRadius: 10,
    marginRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  uploadBtn: {
    borderRadius: 30,
    padding: 0
  },
  uploadIcon: {
    width: 15,
    height: 15,
    marginRight: 4
  },
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  closeIcon: {
    position: 'absolute',
    right: theme.spacing(3),
    cursor: 'pointer',
    width: theme.spacing(3),
    height: theme.spacing(3),

    fill: colors.blueGrey[900],

    '&:hover': {
      opacity: 0.5
    }
  },
  actions: {
    flexDirection: 'row-reverse'
  },
  header: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    display: 'flex',
    alignItems: 'center'
  },
  content: {
    maxHeight: '60vh',
    overflowY: 'auto'
  },
  cropContainer: {
    position: 'relative',
    width: '100%',
    height: 200,
    background: '#333',
    [theme.breakpoints.up('sm')]: {
      height: 400,
    },
  },
  cropButton: {
    flexShrink: 0,
    marginLeft: 16,
  },
  controls: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  sliderContainer: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
  },
  sliderLabel: {
    [theme.breakpoints.down('xs')]: {
      minWidth: 65,
    },
  },
  slider: {
    padding: '22px 0px',
    marginLeft: 32,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      margin: '0 16px',
    },
  },
}));

const ImageSelector = ({
  value,
  fieldValue,
  onChange,
  id: fieldId,
  name,
  disabled = false,
  minwidth,
  hideSelectButton
}) => {
  const classes = useStyles();
  return (
    <Grid container alignItems="center" className={classes.root}>
      <Grid item style={{ position: 'relative' }}>
        {
          !fieldValue ? <div className={classes.cameraIcon}>
            <CameraIcon />
          </div> :
            <img
              className={classes.image}
              src={
                typeof fieldValue === 'string'
                  ? fieldValue
                  : value[`${fieldId}-content`]
              }
              alt='selector'
            />
        }
        {fieldValue && !disabled && (
          <IconButton
            className={classes.close}
            disabled={disabled}
            onClick={() => {
              onChange({
                [fieldId]: null,
                [`${fieldId}-content`]: ''
              });
            }}>
            <CancelIcon />
          </IconButton>
        )}
      </Grid>
      {
        !hideSelectButton &&
        <Grid item>
          <div className={classes.wrapper}>
            <Button disabled={!!fieldValue || disabled} variant="outlined" size="small" className={classes.uploadBtn}>
              <input
                accept="image/*"
                className="hidden"
                id={`file-${fieldId}`}
                onChange={event => {
                  if (event.target.files.length > 0) {
                    const [selectedFile] = event.target.files;
                    const fr = new FileReader();
                    fr.onload = function () {
                      const img = new Image();
                      img.onload = async () => {
                        if (minwidth && img.width < minwidth) {
                          return alert(`Width must be at least ${minwidth}px.`);
                        }
                        onChange({
                          file: selectedFile,
                          fileContent: fr.result
                        });
                      };
                      img.src = fr.result;
                    };
                    fr.readAsDataURL(selectedFile);
                    event.target.value = null;
                  }
                }}
                type="file"
              />
              <label
                className={classes.label}
                htmlFor={fieldValue ? '' : `file-${fieldId}`}>
                <UploadIcon className={classes.uploadIcon} />
                {name || 'Upload'}
              </label>
            </Button>
          </div>
        </Grid>
      }
    </Grid>
  );
};
ImageSelector.propTypes = {
  value: PropTypes.any,
  fieldValue: PropTypes.string,
  onChange: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  minwidth: PropTypes.any,
  hideSelectButton: PropTypes.any
};
export default ImageSelector;
